import { render, staticRenderFns } from "./QuizPlatter.vue?vue&type=template&id=0a3cf5fe&scoped=true&"
import script from "./QuizPlatter.vue?vue&type=script&lang=js&"
export * from "./QuizPlatter.vue?vue&type=script&lang=js&"
import style0 from "./QuizPlatter.vue?vue&type=style&index=0&id=0a3cf5fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3cf5fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
